module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-24-98efdaf4f46c2891bb47f6b82f59bb44.jpg";